module.exports = __webpack_public_path__ + "img/margherita.559e7d3b.jpg";